<template>
<router-view />
</template>